import axios from "axios";
import {
    BASE_URL,
} from "../constants";

const axiosInstance = axios.create({
    baseURL: BASE_URL,
    headers: {
        'Access-Control-Allow-Origin': '*',
        //responseType: "json", // By default.
        //xsrfCookieName: "XSRF-TOKEN", // By default. Is the name of the cookie to use as a value for xsrf token
        //xsrfHeaderName: "X-XSRF-TOKEN", // By default. Is the name of the http header that carries the xsrf token value
        //maxContentLength: 2000, // defines the max size of the http response content in bytes allowed in node.js
        //maxBodyLength: 2000, // (Node only option) defines the max size of the http request content in bytes allowed
        //timeout: 10000,
    },
    withCredentials: true,
    timeout: 60 * 1000
});


export { axiosInstance }